import { Location } from 'src/app/core/models/admin';
import { Items } from 'src/app/core/models/common/items.model';
import { IMAGE_SRC, STATUS_OPTIONS } from '../../shared-constants';

export enum ColumnIds {
  LOCATION_CODE = 'locationCode',
  LOCATION_NAME = 'locationName',
  PACKAGE_SLIC = 'pkgSlic',
  HUB_SLIC = 'hubSlic',
  MNEMONIC = 'mnemonic',
  GROUP = 'locationGroups',
  COUNTRY = 'country',
  REGION = 'region',
  DISTRICT = 'district',
  SETUP = 'locationSetup',
  MESSAGING = 'messaging',
  GIO = 'gioEnabled',
  BYOD = 'byod',
  IDO = 'ido',
  API_KEY = 'apiKey',
  ACTION = 'action',
}

export const ColumnText = {
  LOCATION_CODE: $localize`Location Code`.toUpperCase(),
  LOCATION_NAME: $localize`Location Name`.toUpperCase(),
  PACKAGE_SLIC: $localize`PKG SLIC`.toUpperCase(),
  HUB_SLIC: $localize`HUB SLIC`.toUpperCase(),
  MNEMONIC: $localize`Mnemonic`.toUpperCase(),
  LOCATION_GROUPS_CODE: $localize`Groups`.toUpperCase(),
  COUNTRY: $localize`Country`.toUpperCase(),
  REGION: $localize`Region`.toUpperCase(),
  DISTRICT: $localize`District`.toUpperCase(),
  SETUP: $localize`Setup`.toUpperCase(),
  MESSAGING: $localize`Messaging`.toUpperCase(),
  GIO: $localize`GIO`.toUpperCase(),
  BYOD: $localize`BYOD`.toUpperCase(),
  IDO: $localize`IDO`.toUpperCase(),
  API_KEY: $localize`API KEY`.toUpperCase(),
  ACTION: $localize`Actions`.toUpperCase(),
};

export const CONSTS = {
  WELCOME_TEXT: $localize`Location Admin`,
  CANCEL: `cancel`,
  ADD: `add`,
  REMOVE_LOCATION: $localize`Remove Location`,
  REMOVE_LOCATION_MSG: $localize`Please remove all users prior to deleting a location.`,
  OK: $localize`Ok`,
  DELETE: 'delete',
  EDIT: 'edit',
  YES: $localize`Yes`,
  NO: $localize`No`,
  CONFIRM_REMOVE: $localize`Are you sure you want to remove the following location:`,
  BACK: $localize`Back`,
  CONTINUE: $localize`Continue`,
  ALERT: $localize`Alert!`,
};

export const MESSAGING_ICONS: Items[] = [
  { id: STATUS_OPTIONS.ACTIVE, src: IMAGE_SRC.ACTIVE, selected: true },
  { id: STATUS_OPTIONS.DEACTIVATED, src: IMAGE_SRC.CANCEL, selected: true },
];

export const GIO_ICONS: Items[] = [
  { id: STATUS_OPTIONS.ACTIVE, src: IMAGE_SRC.ACTIVE, selected: true },
  { id: STATUS_OPTIONS.DEACTIVATED, src: IMAGE_SRC.CANCEL, selected: true },
];

export const BYOD_ICONS: Items[] = [
  { id: STATUS_OPTIONS.ACTIVE, src: IMAGE_SRC.ACTIVE, selected: true },
  { id: STATUS_OPTIONS.DEACTIVATED, src: IMAGE_SRC.CANCEL, selected: true },
];

export const IDO_ICONS: Items[] = [
  { id: STATUS_OPTIONS.ACTIVE, src: IMAGE_SRC.ACTIVE, selected: true },
  { id: STATUS_OPTIONS.DEACTIVATED, src: IMAGE_SRC.CANCEL, selected: true },
];

export const API_KEY_ICONS: Items[] = [
  { id: STATUS_OPTIONS.ACTIVE, src: IMAGE_SRC.ACTIVE, selected: true },
  { id: STATUS_OPTIONS.DEACTIVATED, src: IMAGE_SRC.CANCEL, selected: true },
];

export const SETUP_DROPDOWN: Items[] = [
  { id: 'OSP In', selected: true },
  { id: 'OSP Out', selected: true },
  { id: 'ASC', selected: true },
  { id: 'Brown', selected: true },
  { id: 'Customer', selected: true },
];

export const EXCEL_FILE_NAME = 'location-admin-data';

export type SelectedLocationType = Location & { index: number };
export type FilteredLocation = Omit<Location, 'id'> & {
  locationGroups?: string;
};
